import React from "react";
import { Link } from "react-router-dom";
import LeftCaretIcon from "../Layout/Icons/LeftCaretIcon";

const BackButton = ({ routeId, location }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="back-button">
      <Link
        to={{ pathname: `/${routeId}/customize/`, search: location.search }}
        className={
          isMobile
            ? "back-button-mobile"
            : "button button--step button--step-prev"
        }
      >
        <LeftCaretIcon />
        {isMobile ? "" : "Back to Editor"}
      </Link>
    </div>
  );
};

export default BackButton;
